export default __webpack_public_path__ + "static/media/Girdle of the Sundered Skies.c7d58446.jpg";